import { useReducer } from 'react'
import { GlobalContext } from './GlobalContext'

const win = window
let pId = ''
let seriesId = ''

if (window.location.href.includes('localhost')) {
  win['isLoggedIn'] = 'false'
  // seriesId = 'watch_series_9_series_da_22022024';
  // seriesId = 'iphone_15_series_da_22022024'
  // seriesId = 'iphone_15_pro_series_da_22022024';
  seriesId = 'ipadpro13-inch_da_29022024'; //airpodsmax_da_29022024
  !!!win['base_portal_url'] && (win['base_portal_url'] = 'http://ssta004:8080')
  !!!win['store_order_track'] && (win['store_order_track'] = '/wps/portal/web/personal/store/order')
  !!!win['home_page_url'] && (win['home_page_url'] = '/wps/wcm/connect/en/personal')
  !!!win['errorPageURL'] && (win['errorPageURL'] = '/wps/portal/web/personal/store/error')
  !!!win['cart_app_url'] && (win['cart_app_url'] = '/wps/portal/web/personal/e-commerce/cart')
} else {
  pId = new URL(window.location.href).searchParams.get('vId');
  seriesId = new URL(window.location.href).searchParams.get('deviceId');
  const currentURL = window.location.href;
  const hostname = window.location.hostname
  let cartEndPoint = '/wps/portal/web/personal/e-commerce/cart';
  
  if(!hostname.includes('mobily.com.sa')) {
    if (currentURL.includes('subsidy')) {
      cartEndPoint = "/wps/portal/web/personal/e-commerce/cart-subsidy";
    }
  
    if (currentURL.includes('gtm')) {
      cartEndPoint = "/wps/portal/web/personal/e-commerce/cart-gtm";
    }
  }

  win['base_portal_url'] = window.location.origin;
  win['store_order_track'] = '/wps/portal/web/personal/store/order';
  win['home_page_url'] = '/wps/wcm/connect/en/personal';
  win['errorPageURL'] = '/wps/portal/web/personal/store/error';
  win['cart_app_url'] = cartEndPoint;
}

const lang = window.location.href.includes('localhost') ? 'en' : document.documentElement.lang
lang === 'ar' ? (document.documentElement.dir = 'rtl') : ''
const rtl = lang === 'ar'
!!!win['lang'] && (win['lang'] = lang)
document.documentElement.lang = lang
const dir = lang === null || lang === 'en' ? 'ltr' : 'rtl'
const deviceTradeUrl = rtl
  ? 'https://mobily.northladder.net/sa-ar/'
  : 'https://mobily.northladder.net/sa-en/'

const initialState = {
  rtl,
  dir,
  lang,
  seriesId,
  xCoId: '',
  deviceFlow:'',
  pageToDisplay: 'ProductDetails',
  subPageToDisplay: 'deviceLogin',
  loading: false,
  filters: [],
  msisdn: '',
  cartId: '',
  scData: {},
  OTPData: {},
  productId: '',
  graphQlResponse: {},
  productData: {},
  encryptedMSISDN: '',
  otpValue: '',
  promotionType: '',
  promotionData: [],
  raqiPromotion: [],
  wajidPromotion: [],
  customerAccount: {},
  promotionApplied: {},
  promoTypeCode: '',
  promoTypeValue: '',
  promoAmount: '',
  promoPeriod: '',
  deviceTradeLink: deviceTradeUrl,
  packageEligibility: {},
  appliedInstallment: {},
}

const reducer = (state, action) => {
  switch (action.type) {
    case 'LOADER':
      return {
        ...state,
        loading: action.payload.loading,
      }

    case 'XCOID':
      return {
        ...state,
        xCoId: action.payload.xcoid,
      }

    case 'FILTERS_DATA':
      return {
        ...state,
        filters: action.payload.filters,
      }

    case 'PAGE_TO_DISPLAY':
      return {
        ...state,
        pageToDisplay: action.payload.pageToDisplay,
      }

    case 'DEVICE_FLOW':
      return {
        ...state,
        deviceFlow: action.payload.deviceFlow,
      }

    case 'SUB_PAGE_TO_DISPLAY':
      return {
        ...state,
        subPageToDisplay: action.payload.subPageToDisplay,
      }

    case 'DEVICE_MOBILENUMBER':
      return {
        ...state,
        msisdn: action.payload.msisdn,
        encryptedMSISDN: action.payload.encryptedMSISDN,
      }

    case 'SET_SHOPPING_CARTID':
      return {
        ...state,
        cartId: action.payload.cartId,
      }

    case 'SET_SHOPPING_DATA':
      return {
        ...state,
        scData: action.payload.scData,
      }

    case 'INITATE_OTP_DATA':
      return {
        ...state,
        OTPData: action.payload.OTPData,
      }

    case 'CUSTOMER_ACCOUNT_BY_NUMBER':
      return {
        ...state,
        customerAccount: action.payload.customerAccount,
      }

    case 'CAPTURE_OTP_VALUE':
      return {
        ...state,
        otpValue: action.payload.otpValue,
      }

    case 'PRODUCT_VARIANT_ID':
      return {
        ...state,
        productId: action.payload.productId,
      }

      case 'GRAPHQL_RESPONSE_SUCCESS':
        return {
          ...state,
          graphQlResponse: action.payload.graphQlResponse,
        }

    case 'PRODUCT_DATA':
      return {
        ...state,
        productData: action.payload.productData,
      }

    case 'PROMOTIONS_DATA':
      return {
        ...state,
        promotionData: action.payload.promotionData,
      }

    case 'PROMOTION_APPLIED':
      return {
        ...state,
        promotionApplied: action.payload.promotionApplied,
        promoTypeCode: action.payload.promoTypeCode,
        promoTypeValue: action.payload.promoTypeValue,
        promoAmount: action.payload.promoAmount,
        promoPeriod: action.payload.promoPeriod,
      }

    case 'RAQI_PROMOTION':
      return {
        ...state,
        raqiPromotion: action.payload.raqiPromotion,
        promotionType: action.payload.promotionType,
      }

    case 'WAJID_PROMOTION':
      return {
        ...state,
        wajidPromotion: action.payload.wajidPromotion,
        promotionType: action.payload.promotionType,
      }

    case 'INSTALMENT_PACKAGE_ELIGIBILITY':
      return {
        ...state,
        packageEligibility: action.payload.packageEligibility,
      }

    case 'APPLIED_INSTALLMENT':
      return {
        ...state,
        appliedInstallment: action.payload.appliedInstallment,
      }
    default:
      return state
  }
}

export const GlobalProvider = props => {
  const [state, dispatch] = useReducer(reducer, initialState)

  return (
    <GlobalContext.Provider value={{ state, dispatch }}>{props.children}</GlobalContext.Provider>
  )
}
